import { Navigate, useLocation } from 'react-router-dom';

export function DiscoverRedirect() {
  const location = useLocation();
  return <Navigate to={`/${location.search}`} replace />;
}
